export enum ContentContextType {
    Undefined,
    Email,
    Page
}
